export default __webpack_public_path__ + "static/media/money.cdd2a243.svg";